export default __webpack_public_path__ + "static/media/itevenz.b18428bc.png";